function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.84555 1C6.72667 1 7.46094 1.73427 7.46094 2.61539C7.46094 3.49651 6.72667 4.23077 5.84555 4.23077C4.96443 4.23077 4.23017 3.49651 4.23017 2.61539C4.23017 1.73427 4.96443 1.07343 5.84555 1ZM5.84555 3.49651C6.35954 3.49651 6.72667 3.12937 6.72667 2.61539C6.72667 2.1014 6.35954 1.73427 5.84555 1.73427C5.33156 1.73427 4.96443 2.17483 4.96443 2.61539C4.96443 3.12937 5.33156 3.49651 5.84555 3.49651Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.1193 1C17.2382 1 16.5039 1.73427 16.5039 2.61539C16.5039 3.49651 17.2382 4.23077 18.1193 4.23077C19.0004 4.23077 19.7347 3.49651 19.7347 2.61539C19.7347 1.73427 19.0004 1.07343 18.1193 1ZM18.1193 3.49651C17.6053 3.49651 17.2382 3.12937 17.2382 2.61539C17.2382 2.1014 17.6053 1.73427 18.1193 1.73427C18.6333 1.73427 19.0004 2.17483 19.0004 2.61539C19.0004 3.12937 18.6333 3.49651 18.1193 3.49651Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.0879 10.6923H19.411C21.3737 10.6923 22.9648 12.2834 22.9648 14.2461C22.9648 16.2089 21.3737 17.8 19.411 17.8H19.0879V10.6923Z",
  fill: "#78A7F0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.87695 10.6923H4.55388C2.59114 10.6923 1.00003 12.2834 1.00003 14.2461C1.00003 16.2089 2.59114 17.8 4.55388 17.8H4.87695V10.6923Z",
  fill: "#78A7F0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9802 4.87692C8.74953 4.87711 4.87305 6.4926 4.87305 11.6615V18.7692C4.98074 19.8461 6.55294 21.9999 11.9802 22M11.9807 4.87692C15.2114 4.87711 19.0879 6.4926 19.0879 11.6615V18.7692C18.9802 19.8461 17.408 21.9999 11.9807 22",
  fill: "#507FC8"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.16569 4.23077H5.51953V8.44572C5.70272 8.05229 5.9202 7.69709 6.16569 7.37742V4.23077Z",
  fill: "#78A7F0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7972 4.23083H18.4434V8.44578C18.2602 8.05235 18.0427 7.69715 17.7972 7.37748V4.23083Z",
  fill: "#78A7F0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.18164 17.5761C3.53517 17.7228 3.91751 17.8141 4.31782 17.8391C5.22163 18.517 6.47453 19.0685 8.09734 19.0685V19.7384C5.77557 19.7384 4.1475 18.6502 3.18164 17.5761Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.72055 17.8C10.6017 17.8 11.3359 18.5343 11.3359 19.4154C11.3359 20.2966 10.6017 21.0308 9.72055 21.0308C8.83943 21.0308 8.10517 20.2966 8.10517 19.4154C8.10517 18.5343 8.83943 17.8735 9.72055 17.8ZM9.72055 20.2966C10.2345 20.2966 10.6017 19.9294 10.6017 19.4154C10.6017 18.9014 10.2345 18.5343 9.72055 18.5343C9.20656 18.5343 8.83943 18.9749 8.83943 19.4154C8.83943 19.9294 9.20656 20.2966 9.72055 20.2966Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 7,
  y: 12,
  width: 10,
  height: 4,
  rx: 1.5,
  fill: "black"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.2736 10.4007C15.2736 10.4007 13.2182 10.4007 9.45981 10.4007C5.93632 10.4007 6.17122 13.2173 6.17122 13.2173C6.17122 16.3934 8.93129 16.2136 8.87256 16.2136H15.3323C15.3323 16.2136 17.7987 16.1537 17.7987 13.2173C17.7987 10.2809 15.2736 10.4007 15.2736 10.4007ZM8.57894 14.3559C7.99169 14.3559 7.52189 13.8765 7.52189 13.2772C7.52189 12.6779 7.99169 12.1985 8.57894 12.1985C9.16619 12.2585 9.63599 12.6779 9.63599 13.2772C9.63599 13.8765 9.16619 14.3559 8.57894 14.3559ZM11.985 15.2548C10.4581 15.2548 10.693 13.8165 10.693 13.8165H13.2769C13.2769 13.8165 13.6293 15.2548 11.985 15.2548ZM15.3323 14.3559C14.7451 14.3559 14.2753 13.8765 14.2753 13.2772C14.2753 12.6779 14.7451 12.1985 15.3323 12.1985C15.9195 12.2585 16.3893 12.6779 16.3893 13.2772C16.3893 13.8765 15.9195 14.3559 15.3323 14.3559Z",
  fill: "white"
});

var SvgIBrokerActive = function SvgIBrokerActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIBrokerActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_broker_active.ea807e4f.svg";
export { ForwardRef as ReactComponent };